import "core-js/modules/es.string.replace.js";
import {defineComponent} from 'vue'

export default defineComponent({
    name: "DataFilters",
    methods: {
        bytesToHumanPresent($bytes) {
            if ($bytes === 0) return '0';
            let $toFixedNumber = 0;
            let $tmp = $bytes;
            let $str = 'Б';

            if ($tmp >= 1000) {
                $tmp = $tmp / 1024;
                $str = 'КБ';
            }

            if ($tmp > 1000) {
                $toFixedNumber = 1;
                $tmp = $tmp / 1024;
                $str = 'МБ';
            }

            if ($tmp > 1000) {
                $toFixedNumber = 2;
                $tmp = $tmp / 1024;
                $str = 'ГБ';
            }

            if ($tmp > 1000) {
                $toFixedNumber = 2;
                $tmp = $tmp / 1024;
                $str = 'ТБ';
            }

            Number.isInteger = Number.isInteger || function (value) {
                return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
            };

            // @ts-ignore
            if (Number.isInteger(parseFloat($tmp).toFixed($toFixedNumber) * 1)) {
                $toFixedNumber = 0;
            }

            return parseFloat($tmp).toFixed($toFixedNumber) + ' ' + $str;
        },

        secondsToDateTime(seconds, $dont_show_secs) {
            const days = parseInt(String(seconds / 86400));
            // @ts-ignore
            const hours = parseInt((seconds - days * 86400) / 3600);
            const minutes = parseInt(String((seconds - days * 86400 - hours * 3600) / 60));
            const sec = seconds - days * 86400 - hours * 3600 - minutes * 60;
            let res = '';
            if (days > 0) res += days + 'д ';
            if (hours > 0) res += hours + 'ч ';
            if (minutes > 0) res += minutes + 'м '; //res += sec+'с ';

            if (sec > 0 && !$dont_show_secs) res += sec + 'с ';
            if (days === 0 && hours === 0 && minutes === 0 && sec === 0) return '0';
            return res;
        },

        unixTimeStampToDateTime(seconds, $dont_show_secs = true) {

            if (!seconds)
                return null;

            const date = new Date(seconds * 1000);
            let $time;
            $time = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            $time += ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
            if (!$dont_show_secs) $time += ':' + (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            return this.dateToDMY(date) + ' ' + $time;
        },

        dateToDMY(date) {

            if (!date)
                return null;

            if (!(date instanceof Date)) date = new Date(date);
            const d = date.getDate();
            const m = date.getMonth() + 1; //Month from 0 to 11

            const y = date.getFullYear();
            return '' + (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y;
        },

        dateToYMD(date) {

            if (!date)
                return null;

            if (!(date instanceof Date)) date = new Date(date);
            const d = date.getDate();
            const m = date.getMonth() + 1; //Month from 0 to 11

            const y = date.getFullYear();
            return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        },

        nl2br(str, is_xhtml) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }

            let breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },

        getCurrentDateTimeISO() {
            let $tz = new Date().getTimezoneOffset() * 60000;
            let $date = new Date(Date.now() - $tz);
            return $date.toISOString().replace(/.\d+Z$/g, "");
        },

        unixTimeToISO($unixTime) {
            let $tz = new Date().getTimezoneOffset() * 60000;
            let $date = new Date(($unixTime * 1000) - $tz);
            return $date.toISOString().replace(/.\d+Z$/g, "");
        },

        trimmedString(item, length = 30) {
            return (item?.length > length) ? item.substring(0, length - 3) + "..." : item;
        },

        HtmlToText(text: string, nlToBr?: boolean): string {

            if (!text)
                return text;

            let html = text
            html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
            html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
            html = html.replace(/<\/div>/ig, '\n');
            html = html.replace(/<\/li>/ig, '\n');
            html = html.replace(/<li>/ig, '  *  ');
            html = html.replace(/<\/ul>/ig, '\n');
            html = html.replace(/<\/p>/ig, '\n');
            html = html.replace(/<br\s*[\/]?>/gi, "\n");
            html = html.replace(/<[^>]+>/ig, '');

            return nlToBr ? this.nl2br(html) : html

        },

    }
});